"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FFAnalytics = void 0;
const utils_1 = require("./utils");
const data_1 = require("./data");
class FFAnalytics {
    static sendInit() {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        utils_1.FFAnalyticsUtils.loopAllServices(null, (integ) => {
            for (const siteCategory of integ.getActiveSiteCategories()) {
                integ.sendInit(siteCategory, dlData.userId, dlData.email, dlData.coupon);
            }
            return true;
        }, false);
        return true;
    }
    static sendPage() {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return true;
        }, (integ) => {
            if (!integ.shouldSendEveryPage) {
                return true;
            }
            for (const siteCategory of integ.getActiveSiteCategories()) {
                integ.sendPage(siteCategory, dlData.userId, dlData.email);
            }
            return true;
        });
        return true;
    }
    static sendTrackClubAccountCreate() {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        if (!dlData.isLoggedIn || dlData.email === null || dlData.userId === null) {
            return false;
        }
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubAccountCreate;
        }, (integ) => {
            if (!dlData.isLoggedIn ||
                dlData.email === null ||
                dlData.userId === null) {
                return true;
            }
            integ.sendTrackClubAccountCreate("club", dlData.userId, dlData.email);
            return true;
        });
        return true;
    }
    static sendTrackClubAccountCreateLegacy() {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        if (!dlData.isLoggedIn || dlData.email === null || dlData.userId === null) {
            return false;
        }
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubAccountCreateLegacy;
        }, (integ) => {
            if (!dlData.isLoggedIn ||
                dlData.email === null ||
                dlData.userId === null) {
                return true;
            }
            integ.sendTrackClubAccountCreateLegacy("club", dlData.userId, dlData.email);
            return true;
        });
        return true;
    }
    static sendTrackQuizDayLook(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizDayLook;
        }, (integ) => {
            integ.sendTrackQuizDayLook("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizNightLook(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizNightLook;
        }, (integ) => {
            integ.sendTrackQuizNightLook("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizShoeStyle(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizShoeStyle;
        }, (integ) => {
            integ.sendTrackQuizShoeStyle("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizExerciseFrequency(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizExerciseFrequency;
        }, (integ) => {
            integ.sendTrackQuizExerciseFrequency("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizFirstSelectedPackage(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizFirstSelectedPackage;
        }, (integ) => {
            integ.sendTrackQuizFirstSelectedPackage("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizTopSize(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizTopSize;
        }, (integ) => {
            integ.sendTrackQuizTopSize("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizTopSizeLegacy(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizTopSizeLegacy;
        }, (integ) => {
            integ.sendTrackQuizTopSizeLegacy("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizBottomSize(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizBottomSize;
        }, (integ) => {
            integ.sendTrackQuizBottomSize("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizBottomSizeLegacy(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizBottomSizeLegacy;
        }, (integ) => {
            integ.sendTrackQuizBottomSizeLegacy("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizBottomFit(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizBottomFit;
        }, (integ) => {
            integ.sendTrackQuizBottomFit("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizBottomFitLegacy(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizBottomFitLegacy;
        }, (integ) => {
            integ.sendTrackQuizBottomFitLegacy("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizShoeSize(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizShoeSize;
        }, (integ) => {
            integ.sendTrackQuizShoeSize("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizShoeSizeLegacy(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizShoeSizeLegacy;
        }, (integ) => {
            integ.sendTrackQuizShoeSizeLegacy("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizStyleLegacy(response) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizStyleLegacy;
        }, (integ) => {
            integ.sendTrackQuizStyleLegacy("club", response);
            return true;
        });
        return true;
    }
    static sendTrackQuizStart() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizStart;
        }, (integ) => {
            integ.sendTrackQuizStart("club");
            return true;
        });
        return true;
    }
    static sendTrackQuizStartLegacy() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizStartLegacy;
        }, (integ) => {
            integ.sendTrackQuizStartLegacy("club");
            return true;
        });
        return true;
    }
    static sendTrackClubLanding() {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubLanding;
        }, (integ) => {
            integ.sendTrackClubLanding("club", dlData.coupon);
            return true;
        });
        return true;
    }
    static sendTrackClubLandingLegacy() {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubLandingLegacy;
        }, (integ) => {
            integ.sendTrackClubLandingLegacy("club", dlData.coupon);
            return true;
        });
        return true;
    }
    static sendTrackClubLanding3() {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubLanding3;
        }, (integ) => {
            integ.sendTrackClubLanding3("club", dlData.coupon);
            return true;
        });
        return true;
    }
    static sendTrackClubLanding4() {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubLanding4;
        }, (integ) => {
            integ.sendTrackClubLanding4("club", dlData.coupon);
            return true;
        });
        return true;
    }
    static sendTrackClickCtaLanding3(testName, ctaName, variantName, targetUrl) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClickCtaLanding3;
        }, (integ) => {
            integ.sendTrackClickCtaLanding3("club", testName, ctaName, variantName, targetUrl);
            return true;
        });
        return true;
    }
    static sendTrackClickCtaLanding4(testName, ctaName, variantName, targetUrl) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClickCtaLanding4;
        }, (integ) => {
            integ.sendTrackClickCtaLanding4("club", testName, ctaName, variantName, targetUrl);
            return true;
        });
        return true;
    }
    static sendTrackClubCheckoutStart() {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubCheckoutStart;
        }, (integ) => {
            integ.sendTrackClubCheckoutStart("club", dlData.email);
            return true;
        });
        return true;
    }
    static sendTrackArriveSignupLoginLegacy() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackArriveSignupLoginLegacy;
        }, (integ) => {
            integ.sendTrackArriveSignupLoginLegacy("club");
            return true;
        });
        return true;
    }
    static sendTrackQuizComplete() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizComplete;
        }, (integ) => {
            integ.sendTrackQuizComplete("club");
            return true;
        });
        return true;
    }
    static sendTrackQuizCompleteLegacy() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackQuizCompleteLegacy;
        }, (integ) => {
            integ.sendTrackQuizCompleteLegacy("club");
            return true;
        });
        return true;
    }
    static sendTrackPlanSelected(planName) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackPlanSelected;
        }, (integ) => {
            integ.sendTrackPlanSelected("club", planName);
            return true;
        });
        return true;
    }
    static sendTrackPlanSelectedLegacy(planName, explicit) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackPlanSelectedLegacy;
        }, (integ) => {
            integ.sendTrackPlanSelectedLegacy("club", planName, explicit);
            return true;
        });
        return true;
    }
    static sendTrackAddBillingInfo() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackAddBillingInfo;
        }, (integ) => {
            integ.sendTrackAddBillingInfo("club");
            return true;
        });
        return true;
    }
    static sendTrackAddBillingInfoLegacy() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackAddBillingInfoLegacy;
        }, (integ) => {
            integ.sendTrackAddBillingInfoLegacy("club");
            return true;
        });
        return true;
    }
    static sendTrackAddShippingInfo() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackAddShippingInfo;
        }, (integ) => {
            integ.sendTrackAddShippingInfo("club");
            return true;
        });
        return true;
    }
    static sendTrackAddShippingInfoLegacy() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackAddShippingInfoLegacy;
        }, (integ) => {
            integ.sendTrackAddShippingInfoLegacy("club");
            return true;
        });
        return true;
    }
    static sendTrackClubAddPaymentInfo() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubAddPaymentInfo;
        }, (integ) => {
            integ.sendTrackClubAddPaymentInfo("club");
            return true;
        });
        return true;
    }
    static sendTrackClubAddPaymentInfoLegacy() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubAddPaymentInfoLegacy;
        }, (integ) => {
            integ.sendTrackClubAddPaymentInfoLegacy("club");
            return true;
        });
        return true;
    }
    static sendTrackSubmittedPaymentReviewLegacy() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackSubmittedPaymentReviewLegacy;
        }, (integ) => {
            integ.sendTrackSubmittedPaymentReviewLegacy("club");
            return true;
        });
        return true;
    }
    static sendTrackClubPurchase(price, style, color, coupon) {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        if (dlData.userId === null) {
            throw new Error("User must be logged in to call club purchase");
        }
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubPurchase;
        }, (integ) => {
            if (!dlData.isLoggedIn ||
                dlData.email === null ||
                dlData.userId === null) {
                return true;
            }
            integ.sendTrackClubPurchase("club", dlData.userId, dlData.email, price, style, color, coupon);
            return true;
        });
        return true;
    }
    static sendTrackClubPurchaseLegacy(price, style, color, coupon) {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        if (dlData.userId === null) {
            throw new Error("User must be logged in to call club purchase");
        }
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubPurchaseLegacy;
        }, (integ) => {
            if (!dlData.isLoggedIn ||
                dlData.email === null ||
                dlData.userId === null) {
                return true;
            }
            integ.sendTrackClubPurchaseLegacy("club", dlData.userId, dlData.email, price, style, color, coupon);
            return true;
        });
        return true;
    }
    static sendTrackClubThankyou(price, style, color, coupon) {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        if (dlData.userId === null) {
            throw new Error("User must be logged in to call club thank you");
        }
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubThankyou;
        }, (integ) => {
            if (!dlData.isLoggedIn ||
                dlData.email === null ||
                dlData.userId === null) {
                return true;
            }
            integ.sendTrackClubThankyou("club", dlData.userId, dlData.email, price, style, color, coupon);
            return true;
        });
        return true;
    }
    static sendTrackClubThankyouLegacy(price, style, color, coupon) {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        if (dlData.userId === null) {
            throw new Error("User must be logged in to call club thank you");
        }
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubThankyouLegacy;
        }, (integ) => {
            if (!dlData.isLoggedIn ||
                dlData.email === null ||
                dlData.userId === null) {
                return true;
            }
            integ.sendTrackClubThankyouLegacy("club", dlData.userId, dlData.email, price, style, color, coupon);
            return true;
        });
        return true;
    }
    static sendTrackClubRejoinLegacy(price) {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        if (dlData.userId === null) {
            throw new Error("User must be logged in to call club rejoin");
        }
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackClubRejoinLegacy;
        }, (integ) => {
            if (!dlData.isLoggedIn ||
                dlData.email === null ||
                dlData.userId === null) {
                return true;
            }
            integ.sendTrackClubRejoinLegacy("club", dlData.userId, dlData.email, price);
            return true;
        });
        return true;
    }
    static sendTrackEcommAccountCreate() {
        const dlData = data_1.FFAnalyticsData.extractDlData();
        if (!dlData.isLoggedIn || dlData.email === null || dlData.userId === null) {
            return false;
        }
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackEcommAccountCreate;
        }, (integ) => {
            if (!dlData.isLoggedIn ||
                dlData.email === null ||
                dlData.userId === null) {
                return true;
            }
            integ.sendTrackEcommAccountCreate("ecomm", dlData.userId, dlData.email);
            return true;
        });
        return true;
    }
    static sendTrackEcommAddPaymentInfo() {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackEcommAddPaymentInfo;
        }, (integ) => {
            integ.sendTrackEcommAddPaymentInfo("ecomm");
            return true;
        });
        return true;
    }
    static sendTrackEcommPurchase(orderId, price, coupon) {
        const userId = data_1.FFAnalyticsData.extractDlUserId();
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackEcommPurchase;
        }, (integ) => {
            integ.sendTrackEcommPurchase("ecomm", userId, orderId, price, coupon);
            return true;
        });
        return true;
    }
    static sendTrackEcommThankyou(orderId, price, coupon) {
        const userId = data_1.FFAnalyticsData.extractDlUserId();
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackEcommThankyou;
        }, (integ) => {
            integ.sendTrackEcommThankyou("ecomm", userId, orderId, price, coupon);
            return true;
        });
        return true;
    }
    static sendTrackEcommProductView(productId) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackEcommProductView;
        }, (integ) => {
            integ.sendTrackEcommProductView("ecomm", productId);
            return true;
        });
        return true;
    }
    static sendTrackEcommProductAddToCart(productId) {
        utils_1.FFAnalyticsUtils.loopAllServices((integ) => {
            return integ.shouldSendTrackEcommProductAddToCart;
        }, (integ) => {
            integ.sendTrackEcommProductAddToCart("ecomm", productId);
            return true;
        });
        return true;
    }
}
exports.FFAnalytics = FFAnalytics;
